module.exports = __webpack_public_path__ + "img/occidental-room4.dcef6547.jpg";